import { cn } from '@/utils/cn';
import { motion } from 'framer-motion';
import { FaSpinner } from 'react-icons/fa';

type LoadingProps = {
  message?: string;
  description?: string;
  customStyle?: string;
};

export const Loading = ({
  message,
  description,
  customStyle,
}: LoadingProps) => {
  return (
    <div
      className={cn(
        `flex h-full flex-col items-center justify-center ${customStyle}`,
      )}
    >
      <div className="relative">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'linear' as const,
          }}
          className="m-4"
        >
          <FaSpinner className="bg-gradient-to-r from-linko-dark to-linko-light bg-clip-text text-4xl text-transparent" />
        </motion.div>
        <motion.div
          className="absolute inset-0 m-4 opacity-30"
          animate={{ rotate: -360 }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'linear' as const,
          }}
        >
          <FaSpinner className="text-4xl text-linko-light" />
        </motion.div>
      </div>
      <div className="mt-2 text-center">
        {message && (
          <p className="bg-gradient-to-r from-linko-dark to-linko-light bg-clip-text text-xl font-semibold text-transparent">
            {message}
          </p>
        )}
        {description && <p className="text-gray-dark">{description}</p>}
      </div>
    </div>
  );
};
